import React from 'react';

import BatchIn from './BatchIn';
import BatchOut from './BatchOut';
import { DocumentDirection } from '../../config/DocumentDirection';
import { DialogUI } from '../Interface';

const BatchDialog = (props) => {
  const { documentData, open, onClose } = props;
  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Sarzs'} maxWidth="lg" fullWidth>
      {documentData?.direction === DocumentDirection.INCOMING ? <BatchIn {...props} /> : <BatchOut {...props} />}
    </DialogUI>
  );
};

export default BatchDialog;
